export const NETWORK_SWITCH_ERROR_MESSAGES = {
  pending: "Network switch request is already pending",
  unsupported: "Selected network is not supported",
  unavailable: "Wallet network switch is not available",
} as const;
